import { render, staticRenderFns } from "./InsuranceAuthorizationRecipe.vue?vue&type=template&id=f7c5e7cc&"
import script from "./InsuranceAuthorizationRecipe.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports